import './Banner.css'

export const Banner = () => {
    // JSX
    return (
        <header className="banner">
            <img src="./imagens/imagens/banner.png" alt="O banner principal da página do Organo"/>
        </header>
    )
}